// src/types.ts
import {
  isOpenAPI30 as assertOpenAPI30,
  isOpenAPI31 as assertOpenAPI31,
  isSwagger as assertSwagger
} from "@readme/openapi-parser/lib/assertions";
function isRef(check) {
  return check.$ref !== void 0;
}
var isSwagger = assertSwagger;
var isOpenAPI30 = assertOpenAPI30;
function isOAS30(check) {
  return "openapi" in check && check.openapi !== void 0 && check.openapi.startsWith("3.0");
}
var isOpenAPI31 = assertOpenAPI31;
function isOAS31(check) {
  return "openapi" in check && check.openapi !== void 0 && check.openapi.startsWith("3.1");
}
function isSchema(check, isPolymorphicAllOfChild = false) {
  return check.type !== void 0 || check.allOf !== void 0 || check.anyOf !== void 0 || check.oneOf !== void 0 || isPolymorphicAllOfChild;
}

export {
  isRef,
  isSwagger,
  isOpenAPI30,
  isOAS30,
  isOpenAPI31,
  isOAS31,
  isSchema
};
//# sourceMappingURL=chunk-47ELBTA5.js.map